export default {
      id: "statements-excluded-usage",
      viewBox: "0 0 57 56",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#statements-excluded",
      toString: function () {
        return this.url;
      }
    }